var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{style:(_vm.mergedWrapperStyle)},[_c('div',[_vm._t("default")],2),(_vm.dismissable)?_c('div',{style:(_vm.dismissStyle),on:{"click":_vm.handleDismissClick}},[_vm._v(" ✕ ")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }